import { BaseService } from '@/modules/Core/services/BaseService'
import type { IFactLog } from '../interfaces'

export class LogsFacturacionService extends BaseService<IFactLog> {
  constructor() {
    super({ baseUrl: 'facturacion/logs/' })
  }
}
